/**
 * @generated SignedSource<<13cd8dc0435ae324f4d92f43e186a407>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePoll",
    "kind": "LinkedField",
    "name": "unvotePoll",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "options",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optionVotesCounts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pollVotesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "votedByCurrentUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "votedOptionIndex",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pollDisplayUnvotePollMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pollDisplayUnvotePollMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "be53fe2238d10f6e63f65d17f34a7e0d",
    "id": null,
    "metadata": {},
    "name": "pollDisplayUnvotePollMutation",
    "operationKind": "mutation",
    "text": "mutation pollDisplayUnvotePollMutation(\n  $request: UnvotePollRequestInput!\n) {\n  unvotePoll(request: $request) {\n    id\n    options\n    optionVotesCounts\n    pollVotesCount\n    votedByCurrentUser\n    votedOptionIndex\n  }\n}\n"
  }
};
})();

node.hash = "c77e24cabc09a654912267cab12c4f1a";

module.exports = node;
